import * as Colors from '@brightlayer-ui/colors';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrganizationPointOfContact } from '../services/organization/types';
import { Footer } from './Footer';

const styles = {
    pointOfContactContainer: {
        marginBottom: '10px',
    },
    pointOfContactText: {
        fontWeight: 'bold',
        fontSize: '1.1rem',
        color: Colors.black[500],
    },
    contactInfoContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
    },
    contactInfoText: {
        color: Colors.black[400],
    },
    emailText: {
        color: Colors.blue[400],
    },
};

type PointOfContactFooterProps = {
    pointOfContact: OrganizationPointOfContact;
};

export const PointOfContactFooter: React.FC<PointOfContactFooterProps> = ({ pointOfContact }) => {
    const { t } = useTranslation();
    const { name, email, phoneNumber } = pointOfContact;

    return (
        <Footer>
            <Box sx={styles.pointOfContactContainer}>
                <Typography sx={styles.pointOfContactText}>
                    {t('ORGANIZATION_DETAILS_PAGE.POINT_OF_CONTACT')}
                </Typography>
            </Box>
            <Box sx={styles.contactInfoContainer}>
                <Typography sx={styles.contactInfoText}>{name}</Typography>
                <Typography sx={styles.contactInfoText}>•</Typography>
                <Link href={`mailto:${email}`} underline="none" sx={styles.emailText}>
                    {email}
                </Link>
                {phoneNumber && (
                    <>
                        <Typography sx={styles.contactInfoText}>•</Typography>
                        <Typography sx={styles.contactInfoText}>{phoneNumber}</Typography>
                    </>
                )}
            </Box>
        </Footer>
    );
};
